"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSaleorLinks = void 0;
const batch_http_1 = require("@apollo/client/link/batch-http");
const retry_1 = require("@apollo/client/link/retry");
const auth_1 = require("./auth");
/**
 * Creates list of links for Apollo client.
 * @param linksConfig Configuration for created links.
 */
const createSaleorLinks = ({ apiUrl, tokenExpirationCallback, }) => {
    const invalidTokenLink = (0, auth_1.invalidTokenLinkWithTokenHandler)(tokenExpirationCallback);
    return [
        auth_1.cfAuthLink,
        invalidTokenLink,
        auth_1.authLink,
        new retry_1.RetryLink({
            attempts: {
                max: 5,
                retryIf: error => !!error && error.code === "429",
            },
            delay: {
                initial: 2000,
                max: Infinity,
            },
        }),
        new batch_http_1.BatchHttpLink({ credentials: "include", uri: apiUrl }),
    ];
};
exports.createSaleorLinks = createSaleorLinks;
//# sourceMappingURL=links.js.map